import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import $ from 'jquery';


$(document).ready(function (){

  if ($('.swiper').hasClass('testimonials-slider')){
    new Swiper('.testimonials-slider', {
      modules: [Navigation],

      breakpoints: {
        1800: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 3,
        },
        950: {
          slidesPerView: 2,
        },
        300: {
          slidesPerView: 1,
        },
      },

      spaceBetween: 20,

      direction: 'horizontal',
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
  const sliders = $('.wp-block-gallery').length;

    if(sliders > 0){

      for (let i = 0; i < sliders; i++) {
       let num = i + 1;
       const slider = $('.wp-block-gallery-' + num )
        slider.attr('class','wp-block-gallery-' + num + ' swiper-wrapper').wrap( `<div class='swiper gallery-${num}'></div>` );
        slider.children().addClass('swiper-slide');
        $(`.gallery-${num}`).wrap( `<div class='position-relative gallery-container-${num}'></div>`)
        $(`.gallery-container-${num}`).append(`
        <div class="swiper-button-next-${num}">
            <img src="${imgPath}arrow-right-black.svg" width="45" alt="Arrow right">
        </div>`).prepend(` <div class="swiper-button-prev-${num}">
            <img src="${imgPath}arrow-left-black.svg" width="45" alt="Arrow left">
        </div>`)
        new Swiper('.gallery-' + num , {
          modules: [Navigation],

          breakpoints: {
            1800: {
              slidesPerView: 1,
            },
            1200: {
              slidesPerView: 1,
            },
            950: {
              slidesPerView: 1 ,
            },
            300: {
              slidesPerView: 1,
            },
          },

          spaceBetween: 20,

          direction: 'horizontal',
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next-' + num,
            prevEl: '.swiper-button-prev-' + num,
          },
        });
      }
    }
});


